"use client";

import { animateElement } from './animate-element';
import type { AnimationKeyframeWithOptions } from './hooks/types';
import type { AnimationOptions } from './types';

// Track active animations for a given element
const animations = new WeakMap<Element, any>();

/**
 * @deprecated Use framer-motion's animate function instead or an alternative animation library.
 * Trigger a new animation for an element, with support for interrupting
 * any existing animation on the same element.
 *
 * @param keyframes The keyframe definition
 * @param options Waapi animation options (duration, easing, delay)
 * @returns The animation instance
 *
 * @example
 * animate(element, { opacity: 1 }, { duration: 1000 })
 *  .complete(() => console.log('Animation complete'))
 *  .catch(() => console.log('Animation cancelled'));
 */

export function animate(
  element: HTMLElement,
  keyframe: AnimationKeyframeWithOptions,
  options: AnimationOptions
) {
  // stop and commit any existing animations
  const existingAnimation = animations.get(element);
  if (existingAnimation) {
    existingAnimation.stop();
  }

  // play our new animation
  const animation = animateElement(element, keyframe, options);

  // cache this animation for possible future interruption
  animations.set(element, animation);
  return animation;
}
